import React from 'react';
import { SafeAreaView, Spinner, useThemeColors } from 'smoothie';

export const LoadingView = () => {
    const { getColor } = useThemeColors();

    return (
        <SafeAreaView
            style={{
                flex: 1,
                height: '100%',
                width: '100%',
                alignItems: 'center',
                justifyContent: 'center',
                backgroundColor: getColor('$white'),
            }}
        >
            <Spinner marginVertical={100} />
        </SafeAreaView>
    );
};
